/** Compact "5m ago" / "3h ago" / "2d ago" / ISO date formatter.
 *
 * Used by the live feed, question rows, and author chips. Keeps the
 * threshold ladder tight so different surfaces stay consistent.
 */
export function relativeTime(ts: string | null): string {
  if (!ts) return "";
  const t = Date.parse(ts);
  if (Number.isNaN(t)) return "";
  const diffSec = Math.max(0, Math.floor((Date.now() - t) / 1000));
  if (diffSec < 60) return "just now";
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay < 7) return `${diffDay}d ago`;
  return new Date(t).toISOString().slice(0, 10);
}
